import ThanksPage from '@/pages/ThanksPage';
import ROUTE_NAMES from '@/constants/routeNames';

export default {
    path: '/podziekowanie',
    props: true,
    name: ROUTE_NAMES.THANKS,
    component: ThanksPage,
    meta: {
        title: 'Dziękujemy za wybranie Rodziny - Szlachetna Paczka',
        metaTags: [
            {
                name: 'robots',
                content: 'noindex, follow'
            }
        ]
    },
    // This route guard is used to prevent the user from navigating to the thanks page directly
    beforeEnter (_, from) {
        return !!from.name || { name: ROUTE_NAMES.HOME };
    }
};
